export default "__VITE_ASSET__6843b928__"